import type {
  ChartCrossTableData,
  ChartSingleTableData,
  ChartTableRes,
} from '@/entities/chart/model/types';
import type { WordCloudItem } from '@/features/WordCloud/types';

type BuildWordCloudItemsParams = {
  tableData?: ChartTableRes;
  getLabel: (alias: StringNumberValue) => string;
};

type WordCloudTableRow = ChartSingleTableData[number] | ChartCrossTableData[number];

const getRowCount = (row: WordCloudTableRow) => {
  if ('value' in row) {
    return row.value;
  }

  if ('values' in row && Array.isArray(row.values)) {
    return row.values.reduce((sum, item) => sum + item.value, 0);
  }

  return 0;
};

export const buildWordCloudItemsFromTable = ({
  tableData,
  getLabel,
}: BuildWordCloudItemsParams): WordCloudItem[] => {
  const firstTable = tableData?.tables[0];
  if (!Array.isArray(firstTable)) {
    return [];
  }

  const rows = firstTable.flatMap((row) => {
    if (!('x' in row)) {
      return [];
    }

    return [
      {
        alias: row.x,
        count: getRowCount(row),
      },
    ];
  });

  return rows
    .map((row) => ({
      keyword: getLabel(row.alias),
      count: row.count,
      originalKeyword: String(row.alias),
    }));
};
